(function(){
'use strict';

printPosterController.$inject = ["$scope", "$window", "$rootScope", "$state", "$timeout", "posterData"];
function printPosterController($scope, $window, $rootScope, $state, $timeout, posterData) {
  $scope.npoLogo = _.get(SC.organization, 'branding.header_image', null);

  $scope.qrCodeUrl = window.localStorage.getItem('qrCodeUrl');
  $scope.vanityURL = posterData.vanityURL;

  var printTimeout = void 0;

  $scope.getEntityName = function () {
    if ($state.includes('frs.fundraiser.index') || $state.includes('frs.fundraiser.dashboardindex')) {
      return SC.fundraiser.name;
    }

    if ($state.includes('frs.landing.name.campaign')) {
      return SC.campaign.name;
    }

    if ($state.includes('frs.team.index') || $state.includes('frs.team.dashboardindex')) {
      return SC.team.name;
    }

    return null;
  };

  $scope.enityName = $scope.getEntityName();

  $scope.checkDataAvailability = function () {
    if (!$scope.qrCodeUrl) {
      $scope.error = 'QR Code URL is missing. Please go back and generate QR code first.';
      $rootScope.SC.status.banner = {
        type: 'error',
        msg: $scope.error
      };
      return false;
    }
    return true;
  };

  $scope.$on('$viewContentLoaded', function () {
    if (printTimeout) {
      $timeout.cancel(printTimeout);
    }
    if ($scope.checkDataAvailability()) {
      printTimeout = $timeout(function () {
        $window.print();
      }, 1000); // Delay to ensure rendering
    }
  });
}

angular.module('classy.frs').controller('printPosterCtrl', printPosterController);
})();